/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/requestFlightMiles/controllers/addFlightController.js
*    TO   --> ./legacy-web/src/main/assets/js/request-flight-miles/controllers/add-flight-controller.js
**/

RFM_APP.controller("addFlightController", ["$scope","$timeout",function ($scope,$timeout) {

    var AA_AIRLINE_CODE = "001";
    var AA_AIRLINE = "American Airlines";

    $scope.form.flightInfoList = [];

    $scope.resetFlight = function () {
        $scope.flightInfo = {};
    };

    $scope.addFlight = function () {


        $scope.form.flightInfoList.push({});
        return false;
    };


    $scope.removeFlight = function (idx) {
        $scope.form.flightInfoList.splice(idx, 1);
        $timeout(function () {
            $j("#addFlight").focus();
        },0);

    };


    $scope.updateAirlineCode = function (index) {

        var flight = $scope.form.flightInfoList[index];
        flight.data ={};
        var airlineFlown = flight.airlineFlown;
        flight.data.noMilesAirlines = false;
        if(airlineFlown === "Fiji Airways" || airlineFlown === "Gulf Air" || airlineFlown === "Japan Transocean" || airlineFlown === "Royal Jordanian") {
            flight.data.noMilesAirlines = true;
            $timeout(function () {
                $j('#forceFocus' + index).focus();
            },0);
        }


        if (airlineFlown === AA_AIRLINE) {
            flight.airlineCode = AA_AIRLINE_CODE;
        } else {
            flight.airlineCode = "";
        }
    };

$scope.addFlight();
}]);